// ============================================================
// IMPORTS
// ============================================================
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/tailwind.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import "./assets/style/tokens.css";
import VueMeta from "vue-meta";
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import { initCalendlyTracking } from './utils/calendly';
import { initDemoFormTracking } from './utils/hubspotDemoForm';

Vue.use(VueMeta);
Vue.use(Toast, {
  position: 'top-right',
  timeout: 4000,
  closeOnClick: true,
  pauseOnHover: true,
});

// ============================================================
// MOUNT APP
// ============================================================
function mountApp() {
  if (window.__APP__) return; // already mounted (hot-reload)
  window.__APP__ = new Vue({
    router,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}

mountApp();

// Ecoute la confirmation de reservation Calendly et la pousse dans le
// dataLayer ('demo_booked') pour que GTM puisse compter les demos.
initCalendlyTracking();
// Idem pour le formulaire de demo HubSpot (France).
initDemoFormTracking();

document.dispatchEvent(new Event('render-event'));

// ============================================================
// HOT RELOAD CLEANUP (dev only)
// ============================================================
if (import.meta?.hot) {
  import.meta.hot.accept();
  import.meta.hot.dispose(() => {
    window.__APP__?.$destroy();
    window.__APP__ = null;
  });
}
